import '../../styles/globals.css'
import { TextField, Button, Box, Grid, Typography, CircularProgress, Fade } from '@mui/material'
import karmaStyles from '../../styles/KarmaPool.module.css'
import { Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useKarmaPoolContext } from '../../state/KarmaPoolContext';

function HeaderWelcome(props) {
    return (
        <Box>
            <Fade in={true} timeout={1250}>
                <Box>
                <Typography variant="body2" sx={{ marginTop: "1.575rem" }}>
                    Join the Karma Pool.
                    <br /><br />
                    <b>INVITE CODE {props.inviteCodeDisplay}</b>
                    <br /><br />
                    Access the Karmatic charity platform.
                    <br />
                </Typography>
                <a href={"/karma/register?code=" + props.inviteCode}>
                    <Button
                        type="submit"
                        variant="contained"
                        color="info"
                        size="small"
                        sx={{ backgroundColor: 'rgba(232, 232, 232, 0.5)', marginTop: "1.8rem", marginBottom: "0.75rem" }}>
                        Register
                    </Button>
                </a>
                <Typography variant="body2" sx={{ marginTop: "0.75rem" }}>
                    {props.usesLeft} sign-up codes left
                </Typography>
                </ Box>
            </Fade>
        </Box>
    );
}

function HeaderWelcomeNoInvitesLeft() {
    return (
        <>
            <p className={karmaStyles.homepageDescription}> <strong>INVITE CODE EXP</strong> </p>
            <Typography variant="body2" sx={{ marginTop: "1.5rem" }}>
                0 sign-up codes left, sorry :(
            </Typography>
            <a href="/karma/">
                <Button
                    type="submit"
                    variant="contained"
                    color="info"
                    size='small'
                    sx={{ backgroundColor: 'rgba(232, 232, 232, 0.5)', marginTop: "1.8rem", marginBottom: "0.75rem" }}>
                    BACK
                </Button>
            </a>
        </>
    );
}

function InvitePage(props) {
    const [usesLeft, setUsesLeft] = useState(-1);

    const karmaContext = useKarmaPoolContext();

    useEffect(() => {
        fetchInviteCode();
    }, [])

    function fetchInviteCode() {
        let registerationCodeRequest = karmaContext.getURLBasePath() + 'registrationCodes/' + props.inviteCode;

        fetch(registerationCodeRequest, {
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            })
        })
            .then((response) => response.json())
            .then((data) => {
                console.log("data for notes: " + data);
                setUsesLeft(data.usesLeft);
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    return (
        <>
            {
                usesLeft === -1 ?
                    <Grid item xs={12} sx={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "4rem" }}>
                        <Typography variant="body2" component="div" gutterBottom sx={{ color: "rgba(221, 221, 221, 0.375)" }}>
                            <CircularProgress variant="indeterminate" size={24} sx={{ color: "rgba(221, 221, 221, 0.775)" }} />
                        </Typography>
                    </Grid> :
                    usesLeft === 0 ? 
                        <HeaderWelcomeNoInvitesLeft inviteCode={props.inviteCode} /> : 
                        <HeaderWelcome usesLeft={usesLeft} inviteCode={props.inviteCode} inviteCodeDisplay={props.inviteCodeDisplay} />
            }
        </>
    );
}

export default InvitePage;


